import { Injectable } from '@angular/core';
import { LMToolbarServiceBase } from './lm-toolbar-service.base';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LMToolbarServiceAdapter } from './lm-toolbar-service-adapter';
import { AppConstants } from '@app/utils';

@Injectable()
export class LMDynamicToolbarService extends LMToolbarServiceBase {
  constructor(
    public lmToolbarServiceAdapter: LMToolbarServiceAdapter
  ) {
    super(lmToolbarServiceAdapter);
  }

  public getRelatedActionMenuItems(relationActionUrl: string): Observable<RelatedMenuItemResponse> {
    return new Observable<RelatedMenuItemResponse> (observer => {
      this.lmToolbarServiceAdapter.http
        .get(relationActionUrl).pipe(
          catchError(error => {
            this.lmToolbarServiceAdapter.lmLoggerService.error(error);
            return throwError(error || 'Server error');
          }))
        .subscribe((res: any) => {
          this.lmToolbarServiceAdapter.lmLoggerService.log('Related DataViewSet retrieved');
          if (res?.actionSpec.type === AppConstants.ACTION_TYPE_CREATE
          ||  res?.actionSpec.type === AppConstants.ACTION_TYPE_SET
          ||  res?.actionSpec.type === AppConstants.ACTION_TYPE_IMPORT) {
            const headerRelMenItem: RelatedMenuItem[] = [ { text: res.dataViewSet.header.representativeText, resourceId: res.dataViewSet.header.resourceId } ];
            observer.next({ actionSpec: res.actionSpec, relatedMenuItems: headerRelMenItem });
            observer.complete();
          } else {
            let i = 0;
            const relMenuItems: RelatedMenuItem[] = [];
            const dataViewSet = res.dataViewSet;
            dataViewSet.data.forEach(dataView => {
              relMenuItems[ i++ ] = { text: dataView.representativeText, resourceId: dataView.resourceId };
            });
            observer.next({ actionSpec: res.actionSpec, relatedMenuItems: relMenuItems });
            observer.complete();
          }
        });
    });
  }
}

export interface RelatedMenuItem {
  resourceId: string;
  text: string;
}

export interface RelatedMenuItemResponse {
  actionSpec: LMActionSpec;
  relatedMenuItems: RelatedMenuItem[];
}
